import { useEffect } from "react"

import { useEditor } from "@craftjs/core"
import { Funnel, ListPlus, RemoveFormatting, Wrench, XIcon } from "lucide-react"
import { Button, DefaultTooltip, Separator, ToggleOptionGroup, ToggleOptionGroupItem } from "twyne-new.ui"

import Utilities from "../Utilities"

import AddProps from "./Add"
import FilterProps from "./Filter"
import ResetProps from "./Reset"
import { ToolbarProvider, useToolbar } from "./context"

export default function ToolbarWrapper(props) {
  return <ToolbarProvider>
    <ToolbarSidebar {...props} />
  </ToolbarProvider>
}

const ToolbarSidebar = ({ properties, resetProps }) => {
  const { toolbar = [] } = useToolbar()
  const { actions } = useEditor()

  useEscapeDeselect()

  return <div className='mx-2 flex items-center gap-2'>
    <ToggleOptionGroup type='multiple' className='flex-1 px-1 py-px' value={toolbar}>
      <Item
        icon={Wrench}
        tooltip='Utilities'
        value='utilities'
        wrapper={Utilities} />
      <Item
        icon={ListPlus}
        tooltip='Add properties'
        value='addProps'
        wrapper={AddProps}
        wrapperProps={{ ...properties }}
        disabled={toolbar.includes('filterProps')}
      />
      <Item
        icon={RemoveFormatting}
        tooltip='Reset properties'
        value='resetProps'
        wrapper={ResetProps}
        wrapperProps={{ ...resetProps }}
      />
      <Item
        icon={Funnel}
        tooltip={toolbar.includes('filterProps') ? 'Show all properties' : 'Filter only properties with values'}
        value='filterProps'
        wrapper={FilterProps}
      />
    </ToggleOptionGroup>
    <Separator orientation='vertical' className='h-4 my-0' />
    <Button variant='ghost' color='neutral' size='sm' className='h-6 py-0' onClick={() => actions.selectNode()}>
      <XIcon size={14} />
    </Button>
  </div>
}

const Item = ({ icon: Icon, tooltip, value, wrapper: Wrapper, wrapperProps = {}, disabled }) => <>
  <ToggleOptionGroupItem disabled={disabled} value={value} className='w-full hover:not-data-[state=on]:bg-(--color-gray-300) dark:hover:not-data-[state=on]:bg-(--color-gray-1200)'>
    <DefaultTooltip content={tooltip} triggerProps={{ className: 'w-full flex justify-center' }}>
      <Wrapper {...wrapperProps} trigger={<div className='w-full h-full flex justify-center items-center'> <Icon size={14} /> </div>} />
    </DefaultTooltip>
  </ToggleOptionGroupItem>
</>

const useEscapeDeselect = () => {
  const { actions } = useEditor()

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape' && !isEditable(event.target)) actions.selectNode()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [actions])
}

const isEditable = target => target instanceof Element && Boolean(target.closest('input, textarea, select, [contenteditable="true"]'))
